import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';
import { ISubZone } from './interfaces';

export const getSubZoneList = (data: IDynamicTableParams) => {
  return instance()
    .post<ISubZone[]>('/system/list', data)
    .then((response) => response.data);
};

export const getSubZoneAvailableColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/system/availableColumns')
    .then((response) => response.data);
};

export const getSubZoneAvailableGroupColumns = () => {
  return instance()
    .post<IAvailableGroupColumnModel[]>('/system/availableGroupColumns')
    .then((response) => response.data);
};

export const loadSubZone = (systemId: number) => {
  return instance()
    .get<ISubZone>('/system/load/' + systemId)
    .then((response) => response.data);
};

export const createSubZone = (system: ISubZone) => {
  return instance()
    .post<ISubZone>('/system/save', system)
    .then((response) => response.data);
};

export const updateSubZone = (system: ISubZone) => {
  return instance()
    .post<ISubZone>(`/system/${system.systemId}/update`, system)
    .then((response) => response.data);
};

export const deleteSubZone = (systemId: number) => {
  return instance()
    .post('/system/archive', { systemId })
    .then((response) => response.data);
};

export const recoverSubZone = (systemId: number) => {
  return instance()
    .post('/system/recover', { systemId })
    .then((response) => response.data);
};
